<template>
	<div class="unlock-post-with-tokens-modal">
		<FullBackdrop>
			<div class="container spinner" v-if="sendingLoading">
				<Spinner />
			</div>
			<div class="container" v-if="!sendingLoading && !postUnlocked">
				<h3 class="modal-title">Desbloquear Contenido</h3>
				<p class="content-text">{{$t('tokens_modal.description_unlock_post', {tokens_quantity: post.tokens_quantity})}} <span class='username'>@{{model.username}}</span></p>
				<p class="content-text">{{$t('tokens_modal.tokens_available_quantity', {balance: balanceLoaded ? balance : ''})}}</p>
				<p class="content-text error-message" v-if="post.tokens_quantity>balance && balanceLoaded">
				{{$t('tokens_modal.not_enough_tokens_to_unlock')}}</p>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
					<router-link
							class="action"
							:to="{ name: 'purchase.tokens' }"
							v-if="post.tokens_quantity>balance && balanceLoaded"
						>
						<button>{{$t('tokens_modal.button_buy_tokens')}}</button>
					</router-link>
					<button v-if="post.tokens_quantity<=balance" @click="sendTokens">{{$t('tokens_modal.button_unlock')}}</button>
				</div>
			</div>
			<div class="container" v-if="postUnlocked">
				<h3 class="modal-title" style="color:green;">Desbloqueado</h3>
				<p class="content-text">{{$t('tokens_modal.success_transaction', {tokens_quantity: post.tokens_quantity})}}</p>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
				</div>
			</div>
		</FullBackdrop>
	</div>
</template>
<script>
import FullBackdrop from "./FullBackdrop";
import resources from "../resources";
import Spinner from "../components/Spinner";
import EventBus from "../eventbus";

export default {
  components: { FullBackdrop, Spinner },
  props: {
    model: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      balance: 0,
      sendingLoading: false,
      postUnlocked: false,
      balanceLoaded: false,
    };
  },
  methods: {
    cancelHandler() {
      this.$emit("cancel");
    },
    getTokensBalance() {
      resources.tokensBalance.index({}).then((response) => {
        this.balance = parseFloat(response.data.data.balance);
        this.balanceLoaded = true;
      });
      // let readBaseUrl = process.env.VUE_APP_ROOT_API.replace(/\/+$/, "");
      // this.$http.get(readBaseUrl+'/tokens/balance')
      // .then(data => {
      // 	this.balance = data.body.data.balance;
      // 	this.balanceLoaded = true;
      // });
    },
    sendTokens() {
      this.sendingLoading = true;
      resources.tokens
        .store({
          model_id: this.model.id,
          post_id: this.post.post_id,
          tokens: this.post.tokens_quantity,
        })
        .then((response) => {
          if (response.data == "ok") {
            this.postUnlocked = true;
            EventBus.unlockPostWithTokens(this.model, this.post);
          }
          this.sendingLoading = false;
        })
        .catch((err) => {
          if (err.data.error && err.data.error == "Not enough tokens") {
            this.notEnoughTokens = true;
          }
          this.sendingLoading = false;
        });
    },
  },
  mounted() {
    this.getTokensBalance();
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/variables";
@import "../styles/classes";

.unlock-post-with-tokens-modal {
  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;
    justify-content: center;
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
      width: 500px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .content-text {
      font-weight: bold;
      text-transform: uppercase;
    }

    & .footer {
      display: flex;
      justify-content: end;

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }
    }
  }

  & button.cancel {
    @extend %fresh-btn;

    border-radius: 0.5rem;
  }

  & .error-message {
    color: red;
  }

  & .username {
    font-weight: bold;
  }
}
</style>
